var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _ellipse, _ellipse2, _path24;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSavings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 168,
    viewBox: "0 0 240 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M189.192 15.2963C214.346 23.4194 233.855 46.2602 238.918 74.8321C243.182 98.9188 236.108 128.504 194.778 142.25C152.593 156.27 34.6222 163.014 12.7355 123.977C-9.15118 84.9402 -4.61258 34.873 40.3662 17.0821C71.887 4.67324 140.066 -0.576008 189.192 15.2963Z",
    fill: "#D4DBE0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M193.133 149.368H123.865V166.362H193.133V149.368Z",
    fill: "#EAEDF0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M198.22 132.374H135.802V149.368H198.22V132.374Z",
    fill: "#D4DBE0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7525 160.938C65.7525 160.938 64.7467 163.995 62.2114 164.26C59.6761 164.526 59.0194 167.192 61.297 167.898C63.5746 168.604 69.4432 165.406 69.4432 165.406L69.277 161.42L65.7525 160.938Z",
    fill: "#016AD4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M100.523 160.938C100.523 160.938 101.538 163.995 104.065 164.26C106.592 164.526 107.257 167.192 104.979 167.898C102.701 168.604 96.8411 165.406 96.8411 165.406L96.999 161.42L100.523 160.938Z",
    fill: "#016AD4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0874 102.141L65.2122 161.486H70.1498L82.527 129.268C86.7043 118.11 94.42 108.625 104.497 102.258L108.129 100.007L75.0874 102.141Z",
    fill: "#00274D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M108.121 100.007L103.017 161.47H96.4588C96.4588 161.47 97.9883 115.215 86.1514 105.364L108.121 100.007Z",
    fill: "#00274D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M109.709 48.5609C109.709 48.5609 135.103 76.053 152.751 84.4252L149.426 92.8722C149.426 92.8722 106.675 78.1876 98.5866 66.7672C90.4986 55.3467 109.709 48.5609 109.709 48.5609Z",
    fill: "#016AD4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M109.709 48.5609C109.709 48.5609 135.103 76.053 152.751 84.4252L149.426 92.8722C149.426 92.8722 106.675 78.1876 98.5866 66.7672C90.4986 55.3467 109.709 48.5609 109.709 48.5609Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5919 23.8014C86.5919 23.8014 87.5395 28.3779 87.1322 31.5507C87.0913 31.8575 86.9902 32.1531 86.8346 32.4207C86.6791 32.6883 86.4722 32.9226 86.2258 33.1101C85.9795 33.2977 85.6985 33.4347 85.399 33.5135C85.0995 33.5922 84.7873 33.6111 84.4805 33.569C83.4832 33.4953 82.5284 33.1356 81.7307 32.533C80.933 31.9304 80.3263 31.1106 79.9835 30.172L78.1132 26.2766C77.8196 25.4573 77.7883 24.5671 78.0236 23.7292C78.2589 22.8914 78.7492 22.1474 79.4265 21.6004C81.8205 19.4077 86.1513 20.9775 86.5919 23.8014Z",
    fill: "#F4A28C"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M78.454 26.9825L77.8472 42.2984L86.3176 42.0326L83.3583 30.9942L78.454 26.9825Z",
    fill: "#F4A28C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4613 24.1337C84.0319 24.3561 82.5816 24.4146 81.1389 24.3081C81.6276 24.8913 81.9352 25.6044 82.0238 26.3599C82.1124 27.1154 81.9782 27.8803 81.6376 28.5606C81.3213 29.2255 80.7834 29.7598 80.1162 30.072C79.4489 30.3841 78.6938 30.4547 77.9801 30.2716L77.3484 24.2915C77.2287 23.4401 77.3417 22.5722 77.6753 21.7797C78.0089 20.9872 78.5508 20.2996 79.2436 19.7897C79.843 19.3455 80.4705 18.9404 81.1222 18.5771C82.7847 17.6884 85.4115 18.5771 86.8163 17.19C86.9591 17.0576 87.1336 16.9639 87.323 16.9181C87.5124 16.8722 87.7104 16.8757 87.8981 16.9282C88.0858 16.9808 88.2568 17.0805 88.3949 17.218C88.5329 17.3554 88.6334 17.526 88.6866 17.7133C89.1687 19.499 89.1853 22.3978 86.8412 23.6768C86.4096 23.9041 85.9434 24.0585 85.4613 24.1337Z",
    fill: "#00274D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1198 28.3613C82.1198 28.3613 81.8787 26.5756 80.5487 26.8746C79.2187 27.1736 79.5595 29.7484 81.3799 29.7733L82.1198 28.3613Z",
    fill: "#F4A28C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0406 26.7167L88.5534 28.3779C88.6369 28.4718 88.6956 28.585 88.7243 28.7073C88.753 28.8296 88.7508 28.9571 88.7178 29.0782C88.6848 29.1994 88.622 29.3105 88.5353 29.4014C88.4486 29.4923 88.3405 29.5601 88.2209 29.5988L86.4836 30.147L87.0406 26.7167Z",
    fill: "#F4A28C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M84.1064 33.3863C83.0297 33.2456 82.0181 32.7922 81.197 32.0823C81.197 32.0823 81.6459 34.8564 85.0291 37.2402L84.1064 33.3863Z",
    fill: "#F4A28C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M108.121 100.58L93.8735 101.626L75.0873 103.022C74.68 102.44 58.6287 79.3006 58.9528 61.6259C59.1274 52.2902 63.8655 44.4911 77.8637 42.315L83.6242 42.1322C85.0294 42.0868 86.4309 41.962 87.822 41.7585C92.2692 41.0857 105.627 40.2634 112.884 52.8882C121.637 68.1791 108.121 100.58 108.121 100.58Z",
    fill: "#016AD4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M94.206 101.801L75.0873 103.03C74.68 102.449 58.6287 79.3089 58.9528 61.6342C69.759 56.6508 87.2152 54.9232 87.2152 54.9232C87.2152 54.9232 90.7813 58.5943 86.5419 63.6608C81.33 69.8902 79.4929 78.4119 82.6018 85.9203C84.6134 90.7542 87.4812 98.4288 93.8569 101.643L94.206 101.801Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7356 48.8018C84.0283 46.5644 81.6497 44.9311 78.9473 44.1407C76.2449 43.3502 73.3603 43.4438 70.715 44.408C60.7401 47.938 43.6912 56.3683 41.8541 73.0795C39.2523 96.8174 77.232 102.025 77.232 102.025L78.4622 95.9869C78.4622 95.9869 39.1193 74.0098 77.232 62.9382C77.232 62.9382 92.477 57.9049 85.7356 48.8018Z",
    fill: "#016AD4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M85.7356 48.8018C84.0283 46.5644 81.6497 44.9311 78.9473 44.1407C76.2449 43.3502 73.3603 43.4438 70.715 44.408C60.7401 47.938 43.6912 56.3683 41.8541 73.0795C39.2523 96.8174 77.232 102.025 77.232 102.025L78.4622 95.9869C78.4622 95.9869 39.1193 74.0098 77.232 62.9382C77.232 62.9382 92.477 57.9049 85.7356 48.8018Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5121 96.8673C78.5121 96.8673 85.0207 96.9836 83.8736 101.02C82.7265 105.057 77.2236 101.992 77.2236 101.992L78.5121 96.8673Z",
    fill: "#F4A28C"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M152.202 85.7957C152.269 85.6462 158.586 84.9651 158.985 85.3804C159.883 86.3356 157.58 86.726 157.58 86.726C157.58 86.726 161.005 86.726 161.495 87.3489C161.986 87.9718 161.288 89.6745 158.279 90.7293C155.269 91.7842 150.141 90.9951 150.141 90.9951L152.202 85.7957Z",
    fill: "#F4A28C"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M180.016 123.944C180.016 123.944 173.366 122.125 171.911 115.937C171.911 115.937 182.227 113.853 182.518 124.492L180.016 123.944Z",
    fill: "#016AD4"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M180.83 123.288C180.83 123.288 176.183 115.937 180.273 109.068C180.273 109.068 188.12 114.052 184.637 123.296L180.83 123.288Z",
    fill: "#016AD4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M182.027 123.288C182.027 123.288 184.521 115.53 191.919 114.06C191.919 114.06 193.315 119.102 187.106 123.313L182.027 123.288Z",
    fill: "#016AD4"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M177.206 123.114L178.553 132.341L187.048 132.374L188.303 123.163L177.206 123.114Z",
    fill: "#00274D"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 158.5,
    cy: 44.4641,
    rx: 30.5,
    ry: 30.4754,
    fill: "#DB8000"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 159.5,
    cy: 43.4649,
    rx: 30.5,
    ry: 30.4754,
    fill: "#EE8B00"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M140.628 46.6478V43.3198H156.66V46.6478H140.628ZM146.74 52.6638V37.1438H150.516V52.6638H146.74ZM165.005 52.4078V34.2318L166.189 35.7678L161.645 38.0718L160.717 34.4238L166.829 31.2558H169.133V52.4078H165.005ZM161.261 53.9758V50.1358H172.973V53.9758H161.261Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavings);
export default __webpack_public_path__ + "static/media/savings.ff925d72fa1436efef2c6c25bf7fb4f0.svg";
export { ForwardRef as ReactComponent };